module.exports = __webpack_public_path__ + "static/media/translate.d8843e92.svg";